import React, {
	useCallback,
	useEffect,
	useRef,
	useState,
	useMemo,
} from "react";

import { DatePicker, Modal } from "antd";
import classes from "./MovingBetweenCashRegister.module.css";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import api from "../../utils/axios";
import useLang from "../../hooks/useLang";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

type Props = {};
const CashRegisterTable = (props: Props) => {
	const [cashRegisterModalData, setCashRegisterModalData] = useState([]);
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [startDate, setStartDate] = useState<any>("");
	const [endDate, setEndDate] = useState<any>("");
	const [filteredData, setFilteredData] = useState([]);
	const [cashRegisterData, setCashRegisterData] = useState<any>([]);
	const { strings } = useLang("filterorder");
	const [tableColumns] = useState<ColDef[]>([
		{
			field: "description",
			headerName: "Description",
			width: 170,
		},
		{
			field: "amount",
			headerName: "Total amount",
			width: 170,
		},
		{
			field: "currency",
			headerName: "Currency",
			width: 170,
		},
	]);

	dayjs.extend(isSameOrAfter);
	dayjs.extend(isSameOrBefore);

	useEffect(() => {
		(async () => {
			try {
				const response = await api.get(
					"Finance/cash-register-transaction-list"
				);
				setCashRegisterData(response.data);
				setFilteredData(response.data);
			} catch (error) {
				console.error("Error fetching transactions:", error);
			}
		})();
	}, []);

	useEffect(() => {
		if (startDate || endDate) {
			const filtered = cashRegisterModalData.filter((item: any) => {
				const itemDate = dayjs(item?.Data, "YYYY-MM-DD"); // Convert item date to Dayjs
				const start = startDate ? dayjs(startDate, "YYYY-MM-DD") : null;
				const end = endDate ? dayjs(endDate, "YYYY-MM-DD") : null;

				console.log(itemDate, "itemDate");
				console.log(start, "START");
				console.log(end, "END");

				return (
					(!start || itemDate.isSameOrAfter(start)) &&
					(!end || itemDate.isSameOrBefore(end))
				);
			});
			setFilteredData(filtered);
		} else {
			setFilteredData(cashRegisterModalData);
		}
	}, [startDate, endDate, cashRegisterModalData]);

	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
		}),
		[]
	);
	let grid = useRef(null);
	const onFirstDataRendered = useCallback((params: any) => {
		(grid.current as any).api.sizeColumnsToFit();
	}, []);
	const onCashRegisterRowClicked = (rowEvent: any) => {
		if (rowEvent.data) {
			const id: number = rowEvent.data.id;
			openCashRegisterReportModal(id);
		}
	};

	let modalGridRef = useRef(null);
	const openCashRegisterReportModal = useCallback(
		async (id: number) => {
			const modalData = await getCashRegisterGrouped(id); //is dynamic, just modify the procedure
			setOpenModal(true);
			if (modalData) {
				let colDefs: any = [];
				const keys = Object.keys(modalData[0]);
				keys.forEach((key) => colDefs.push({ field: key }));
				setModalDataColumnDefs(colDefs);
			}
		},
		[modalGridRef]
	);
	const getCashRegisterGrouped = async (id: number) => {
		try {
			const response = await api.get(
				"Finance/cash-register-grouped-report",
				{
					params: {
						id: id,
					},
				}
			);
			setCashRegisterModalData(response.data);
			return response.data;
		} catch (error) {
			console.error(
				"Error fetching cash register grouped report:",
				error
			);
			throw error;
		}
	};
	const [modalDataColumnDefs, setModalDataColumnDefs] = useState([]);
	return (
		<div className={classes.mainContainer}>
			<Modal
				open={openModal}
				title={""}
				onCancel={() => setOpenModal(false)}
				onOk={() => setOpenModal(false)}
				width={1000}
				okButtonProps={{ className: "bg-blue-400" }}
			>
				<div className={classes.datat}>
					<div className="flex flex-col">
						<p>{strings?.fromdate}</p>
						<DatePicker
							value={startDate ? dayjs(startDate) : null}
							onChange={(e) => {
								console.log(e);
								const formattedStartDate = e
									? e.format("YYYY-MM-DD")
									: null;
								setStartDate(formattedStartDate);
							}}
							className={classes.firstData}
						/>
					</div>
					<div className="flex flex-col">
						<p>{strings?.untill}</p>
						<DatePicker
							value={endDate ? dayjs(endDate) : null}
							onChange={(e) => {
								const formattedEndDate = e
									? e.format("YYYY-MM-DD")
									: null;
								setEndDate(formattedEndDate);
							}}
							className={classes.secondData}
						/>
					</div>
				</div>

				<div className={classes.heroContainer}>
					<div
						className="ag-theme-alpine"
						style={{
							height: 600,
							width: "100%",
						}}
					>
						<AgGridReact
							rowData={filteredData}
							ref={modalGridRef}
							columnDefs={modalDataColumnDefs}
						/>
					</div>
				</div>
			</Modal>

			<div className={classes.heroContainer}>
				<div
					className="ag-theme-alpine"
					style={{
						height: 600,
						width: "100%",
					}}
				>
					<AgGridReact
						rowData={cashRegisterData}
						columnDefs={tableColumns}
						defaultColDef={defaultColDef}
						undoRedoCellEditing={true}
						undoRedoCellEditingLimit={20}
						suppressCopyRowsToClipboard={true}
						defaultExcelExportParams={defaultExcelExportSettings}
						ref={grid}
						enableRangeSelection={true}
						cacheQuickFilter={true}
						onRowClicked={onCashRegisterRowClicked}
						onFirstDataRendered={onFirstDataRendered}
					/>
				</div>
			</div>
		</div>
	);
};

export default CashRegisterTable;
